import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { BuyTickets, GetEventByID } from "../../../controllers/customer/EventosController"; // Asegúrate de que apunte a tu ruta pública
import { Box, Button, Container, Divider, Fab, Grid, IconButton, MenuItem, Paper, TextField, Typography } from "@mui/material";
import { imagesURL, stripePromisePK } from "../../../apiRoutes/apiBase";
import QUDProgress from "../../../components/progress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faMinusCircle, faPlusCircle, faTicket } from "@fortawesome/free-solid-svg-icons";

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import UserContext from "../../../navigation/context/userContext";
import Payments from "../../../components/Payments";
import SignInModal from "../../auth/signInModal";
import ResponseComponent from "../../../components/responseComponent";
import CountdownComponent from "../../../components/CountDownComponent";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

import { SeatsioSeatingChart } from '@seatsio/seatsio-react';
import ReCaptchaGoogle from "../../../components/ReCaptchaGoogle";
import ReactQuill from "react-quill"; // Agregado para renderizar los términos legales dinámicos

const stripePromise = loadStripe(stripePromisePK);

export default function EventTickets() {
    const { userData } = useContext(UserContext);
    const [showModal, setShowModal] = useState(false);

    const [event, setEvent] = useState({});
    const [tickets, setTickets] = useState([]);

    const [sections, setSections] = useState([]);
    const [categories, setCategories] = useState([]);
    
    const [continuar, setContinuar] = useState(false);
    const [total, setTotal] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [comision, setComision] = useState(0);
    const [feeSeats, setFeeSeats] = useState(0);
    const [fee, setFee] = useState(0);

    /** customer data */
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(false);
    const [lastName, setLastName] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [documentType, setDocumentType] = useState('V');
    const [document, setDocument] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [documentError, setDocumentError] = useState(false);
    const [prefix, setPrefix] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [profession, setProfession] = useState('');
    const [especialista, setEspecialista] = useState('');
    const [professionError, setProfessionError] = useState(false);

    const [activeStep, setActiveStep] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [successA, setSuccessA] = useState(false);
    const [show, setShow] = useState(false);
    const [goBack, setGoBack] = useState(false);

    const [selectedSeats, setSelectedSeats] = useState([]);
    const [holdToken, setHoldToken] = useState('');

    const [reCaptcha, setReCaptcha] = useState('');

    const { id } = useParams();
    const history = useHistory();

    const redireccionar = (route) => {
        history.push(route);
    };

    const options = {
        mode: 'payment',
        currency: 'usd',
        amount: 100, // Stripe requiere un número entero (centavos). Tu componente Payments probablemente lo sobrescribe.
        paymentMethodTypes: ['card']
    };

    useEffect(() => {
        handleGetEvent();
        if (userData.user !== undefined) {
            setName(userData.entity.name);
            setLastName(userData.entity.last_name);
            setDocumentType(userData.entity.document_type);
            setDocument(userData.entity.document_number);
            setPrefix(userData.user.prefijo);
            setPhoneNumber(userData.entity.phone);
            setEmail(userData.user.email);
        }
        window.scrollTo(0, 0);
        if (userData.user === undefined) setShowModal(true);
    }, []);

    const handleGetEvent = async () => {
        setIsLoading(true);
        let response = await GetEventByID(id);
        if (response.success === true) {
            setEvent(response.data.event);
            setTickets(response.data.tickets);
            handleSettingTickets(response.data.tickets);
        }
        setIsLoading(false);
    };

    const handleSettingTickets = async (_tickets) => {
        let _sections = [];
        let _categories = [];
        if (_tickets !== undefined) {
            _tickets.forEach(item => {
                _sections.push({
                    uuid: item.uuid,
                    name: item.name, 
                    description: item.description,
                    price: item.price,
                    cantidad: 0,
                    max_selection: item.max_selection,
                    lista_asientos: [],
                    capacity: item.capacity,
                    sold: item.sold,
                    available: item.available,
                    mostrar_disp: true, // Puedes hacerlo dinámico luego si lo agregas al JSON
                });

                _categories.push({
                    category: item.name,
                    price: item.price,
                    description: item.description
                });
            });

            setSections(_sections);
            setCategories(_categories);
        }
    };

    const handleShoppingCart = async (_uuid, _operator, _ticket) => {
        setSections((prevSections) => {
            const updatedSections = [...prevSections];
            const indexToUpdate = updatedSections.findIndex((item) => item.uuid === _uuid);

            if (indexToUpdate !== -1) {
                let _cantidad = updatedSections[indexToUpdate].cantidad;
                
                if (_operator === '+') {
                    if (_cantidad < _ticket.available && _cantidad < _ticket.max_selection)
                        _cantidad = _cantidad + 1;
                } else {
                    if (_cantidad > 0) _cantidad = _cantidad - 1;
                }

                updatedSections[indexToUpdate].cantidad = _cantidad;
                
                let _lista_asientos = [];
                for(let i = 0; i < _cantidad; i++) {
                    _lista_asientos.push({ fil: updatedSections[indexToUpdate].name });
                }
                updatedSections[indexToUpdate].lista_asientos = _lista_asientos;
            }
            return updatedSections;
        });
    };

    const handleTotals = async () => {
        let _subtotal = 0;
        let _comision = 0;
        let _total = 0;
        let _comision_asientos = 0;

        // Leemos los fees dinámicos del backend
        const feePercentage = parseFloat(event.financial?.fee_percentage || 0);
        const feeMinimum = parseFloat(event.financial?.fee_minimum || 0); // Tu mínimo de 0.50
        const feeSeatCost = parseFloat(event.financial?.fee_seats || 1);

        sections.forEach(item => {
            if (event.seatsio_key) {
                _comision_asientos += (item.cantidad * feeSeatCost);
            }
            
            // Subtotal del renglón
            _subtotal += (item.cantidad * item.price);

            // MATEMÁTICA FINANCIERA EXACTA (Igual al backend)
            // Calculamos el % de un solo boleto
            let comisionPorcentajeUnitaria = item.price * (feePercentage / 100);
            // Tomamos el mayor entre el porcentaje y el mínimo (ej. Math.max(0.20, 0.50) = 0.50)
            let comisionUnitariaReal = Math.max(comisionPorcentajeUnitaria, feeMinimum);
            // Multiplicamos por la cantidad de boletos comprados
            _comision += (comisionUnitariaReal * item.cantidad);
        });

        _total = _subtotal + _comision + _comision_asientos;

        setSubTotal(_subtotal);
        setComision(_comision + _comision_asientos);
        setFee(_comision);
        setFeeSeats(_comision_asientos);
        setTotal(_total);
    };

    useEffect(() => {
        handleTotals();
        const encontrado = sections.some(section => section.cantidad > 0);
        setContinuar(encontrado);
    }, [sections]);

    const handleNext = async () => {
        if (activeStep === 1) {
            if (formVerification() === 1) return;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        window.scrollTo(0, 0);
    };

    const formVerification = () => {
        let ban = 0;
        if (name === '') { setNameError(true); ban = 1; }
        if (lastName === '') { setLastNameError(true); ban = 1; }
        if (event.is_document_mandatory && document === '') { setDocumentError(true); ban = 1; }
        if (phoneNumber.length < 11) { setPhoneNumberError(true); ban = 1; }
        if (email === '') { setEmailError(true); ban = 1; }

        // VALIDACIÓN DINÁMICA: Adiós al id === 30
        if (event.requires_profession && profession === '') {
            setProfessionError(true);
            ban = 1;
        }
        return ban;
    };

    const handleSubmit = async (paymentSuccess, payments, automatedPayment = false, paymentMessage = '') => {
        // 1. Si el pago falló en el componente <Payments />, detenemos todo
        if (!paymentSuccess) {
            setTitle('Operación Fallida!');
            setMessage(paymentMessage);
            setSuccessA(false);
            setShow(true);
            return;
        }

        setIsLoading(true);

        // 2. Armamos el objeto del cliente con los datos del formulario
        const clienteObj = {
            nombre: name,
            apellido: lastName,
            documento: documentType + '-' + document, 
            correo: email,
            telefono: prefix + phoneNumber,
            // Agregamos la profesión dinámicamente si el evento la requería
            profesion: event.requires_profession ? `${profession} ${especialista}` : ''
        };

        // 3. Extraemos IDs vitales
        let id_usuario = userData?.user?.id || null;
        const id_comercio = event.merchant?.uuid; // Vital: Enviamos el UUID del organizador
        const montoTotal = parseFloat(subtotal);

        // 4. Filtramos y mapeamos los boletos seleccionados EXACTAMENTE como los espera el backend
        const detalles = sections
            .filter(section => section.cantidad > 0)
            .map(section => ({
                uuid: section.uuid, // Usamos el UUID de la sección
                cantidad: section.cantidad,
                price: section.price,
                description: section.description || '',
                lista_asientos: section.lista_asientos || []
            }));

        // 5. Formateamos el pago
        let pagosArray = [];
        if (payments !== null) {
            pagosArray = [{
                amount: parseFloat(payments.monto),
                reference: payments.referencia,
                id_numero_cuenta: payments.id_numero_cuenta || null
            }];
        }

        try {
            // 6. ¡Disparamos el cohete! Llamamos a tu controlador de React
            let response = await BuyTickets(
                id_usuario,
                id_comercio,
                clienteObj,
                montoTotal,
                comision,
                detalles,
                pagosArray,
                automatedPayment,
                holdToken,
                selectedSeats,
                event.seatsio_key 
            );
            
            if (response.success === true) {
                setTitle('¡Operación Exitosa!');
                // Mostramos el mensaje que nos mandó Laravel ("Revisa tu correo...")
                setMessage(response.message); 
                setSuccessA(true);
            } else {
                setTitle('Operación Fallida');
                setMessage(response.message?.message || response.message || 'Error desconocido.');
                setSuccessA(false);
            }
        } catch (error) {
            console.error("Error en handleSubmit:", error);
            setTitle('Error de Conexión');
            setMessage('No pudimos procesar tu solicitud con el servidor. Intenta nuevamente.');
            setSuccessA(false);
        }

        setShow(true);
        setIsLoading(false);
    };

    const handleOnClose = () => {
        setShowModal(false);
        if (localStorage.getItem('UserAccount') === null) {
            setSuccessA(false);
            setTitle('Inicio de sesión obligatorio');
            setMessage('Para poder comprar boletos debe registrarse y/o iniciar sesión');
            setGoBack(true);
            setShow(true);
        }
    };

    const handleClostResponse = () => {
        if (goBack === true) {
            history.goBack();
        } else {
            if (successA === true) redireccionar('/');
            else setShow(false);
        }
    };

    const handleSelectingSeat = async (selectedObject, _operator) => {
        setSections((prevSections) => {
            const updatedSections = [...prevSections];
            const indexToUpdate = updatedSections.findIndex((item) => item.name === selectedObject.category.label);
            
            if (indexToUpdate !== -1) {
                if (_operator === '+') {
                    const seats = updatedSections[indexToUpdate].lista_asientos;
                    if (selectedObject.seats) {
                        selectedObject.seats.forEach(item => {
                            const [label, fil, col] = item.label.split('-');
                            const seatFound = seats.find(seat => seat.fil === fil && seat.col === col);
                            if (!seatFound) updatedSections[indexToUpdate].lista_asientos.push({ fil, col });
                        });
                    } else {
                        const seatFound = seats.find(seat => seat.fil === selectedObject.labels.parent && seat.col === selectedObject.labels.own);
                        if (!seatFound) updatedSections[indexToUpdate].lista_asientos.push({ fil: selectedObject.labels.parent, col: selectedObject.labels.own });
                    }
                    updatedSections[indexToUpdate].cantidad = updatedSections[indexToUpdate].lista_asientos.length;
                } else {
                    if (selectedObject.seats) {
                        selectedObject.seats.forEach(item => {
                            const [label, fil, col] = item.label.split('-');
                            updatedSections[indexToUpdate].lista_asientos = updatedSections[indexToUpdate].lista_asientos.filter(seat => !(seat.fil === fil && seat.col === col));
                        });
                    } else {
                        updatedSections[indexToUpdate].lista_asientos = updatedSections[indexToUpdate].lista_asientos.filter(seat => !(seat.fil === selectedObject.labels.parent && seat.col === selectedObject.labels.own));
                    }
                    updatedSections[indexToUpdate].cantidad = updatedSections[indexToUpdate].lista_asientos.length;   
                }
            }
            return updatedSections;
        });
    };

    const handleGoBack = () => {
        if (activeStep === 1) handleSettingTickets(tickets);
        setActiveStep(activeStep - 1);
    };

    return (
        <Box mt={-5} pb={5}>
            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={show}
                success={successA}
                title={title}
                message={message}
                actionText={'Aceptar'}
                onClick={() => handleClostResponse()}
            />

            {event.header_image ? (
                <Box 
                    sx={{
                        width: '100%', height: { xs: 205, sm: 250, md: 150, lg: 300, xl: 300 },
                        display: 'flex', flexDirection: 'column',
                        bgcolor: 'primary.main', justifyContent: 'center', alignItems: 'center',
                        backgroundImage: `url(${imagesURL}eventos/${encodeURIComponent(event.header_image)})`,
                        backgroundPosition: 'top', backgroundRepeat: 'no-repeat', backgroundSize: 'contain'
                    }}
                />
            ) : (
                <Box sx={{ width: '100%', height: 300, display: 'flex', flexDirection: 'column', bgcolor: 'primary.main', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant='h6' color={'primary.contrastText'} fontWeight={'bold'} textAlign={'center'}>{event.name}</Typography>
                    <Typography variant='body1' color={'primary.contrastText'} fontWeight={'bold'}>({event.city})</Typography>
                    <Typography variant='body2' color={'link.main'} fontWeight={'bold'} mt={1}>#EVENTOS #QUD #QUDLIFE</Typography>
                </Box>
            )}
            
            <Container>
                <Grid container spacing={3} mt={5}>
                    <Grid item xs={12} sm={12} md={4} lg={5} xl={5}>
                        <Box style={{ width: '100%' }}>
                            <img style={{ width: '100%', borderRadius: 20 }} src={`${imagesURL}eventos/${event.image}`} alt={event.name} />
                        </Box>
                    </Grid>
                    
                    <Grid item xs={12} sm={12} md={8} lg={7} xl={7}>
                        {activeStep > 0 && (
                            <IconButton onClick={() => handleGoBack()}>
                                <FontAwesomeIcon icon={faArrowLeft}/>
                            </IconButton>
                        )}

                        <CountdownComponent refreshTime={600000} />
                        <Typography variant="h5" fontWeight={'bold'}>{event.name}</Typography>
                        
                        {/* PASO 0: SELECCIÓN DE BOLETOS */}
                        {activeStep === 0 && (
                            <>
                                {event.seatsio_key && categories.length !== 0 ? (
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Selecciona los asientos de tu preferencia</Typography>
                                            <Box sx={{ width: '100%', height: 500 }}>
                                                <SeatsioSeatingChart
                                                    workspaceKey="f0117c1e-e399-4ff5-93c2-ee4219d608f5"
                                                    event={event.seatsio_key}
                                                    region="sa"
                                                    pricing={categories}
                                                    priceFormatter={price => '€' + price}
                                                    tooltipInfo={(object) => {
                                                        const category = categories.find(item => item.category === object.label);
                                                        return category ? category.description : '';
                                                    }}
                                                    onObjectSelected={(selectedObject) => {
                                                        handleSelectingSeat(selectedObject, '+');
                                                        setSelectedSeats(selectedObject.chart.selectedSeats);
                                                        setHoldToken(selectedObject.chart.holdToken);
                                                    }}
                                                    onObjectDeselected={(selectableObject) => { handleSelectingSeat(selectableObject, '-'); }}
                                                    session="continue"
                                                />
                                            </Box>
                                        </Grid>
                                        
                                        {/* Resumen del pedido para Seats.io */}
                                        <Grid item xs={12}>
                                            <Paper elevation={4}>
                                                <Typography fontWeight={'bold'} p={1}>Resumen del pedido</Typography>
                                                <Box sx={{ p: 1 }}> 
                                                    {sections.filter(item => item.cantidad > 0).map((item, idx) => (
                                                        <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <Typography>{item.name} x {item.cantidad}</Typography>
                                                            <Typography>{(item.cantidad * item.price).toFixed(2)}</Typography>
                                                        </Box>
                                                    ))}
                                                    <Divider sx={{ mt: 2 }}/>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                                        <Typography>Subtotal</Typography>
                                                        <Typography>{subtotal.toFixed(2)}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography>Fee QUD</Typography>
                                                        <Typography>{fee.toFixed(2)}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography>Service fee</Typography>
                                                        <Typography>{feeSeats.toFixed(2)}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box sx={{ bgcolor: '#F5F8FC', p: 1, mt: 1, borderRadius: 3 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography>Total</Typography>
                                                        <Typography>{total.toFixed(2)} {event.financial?.base_currency || 'USD'}</Typography>
                                                    </Box>
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <>
                                        <Typography variant="h6" mt={2}>Boletos</Typography>
                                        {sections.map((item, idx) => (
                                            <Paper key={idx} elevation={3} sx={{ mt: 2, borderColor: item.cantidad > 0 ? 'success.dark' : '#FFF', bgcolor: item.cantidad > 0 ? 'success.lightTransparency' : '#FFF' }}>
                                                <Grid container spacing={3} p={2}>
                                                    <Grid item xs={12} sm={8}>
                                                        <Typography variant="h6" fontWeight={'bold'}>{item.name}</Typography>
                                                        <Typography variant="body1">{item.description}</Typography>
                                                        <Typography variant="h6" fontWeight={'bold'}>{item.price} {event.financial?.base_currency || 'USD'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} alignItems={'center'}>
                                                        {item.sold < item.capacity ? (
                                                            <>
                                                                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                                                                    <IconButton onClick={() => handleShoppingCart(item.uuid, '-', item)}>
                                                                        <FontAwesomeIcon icon={faMinusCircle}/>
                                                                    </IconButton>
                                                                    <Typography variant="h4" ml={1} mr={1}>{item.cantidad}</Typography>
                                                                    <IconButton onClick={() => handleShoppingCart(item.uuid, '+', item)}>
                                                                        <FontAwesomeIcon icon={faPlusCircle}/>
                                                                    </IconButton>
                                                                </Box>
                                                                {item.mostrar_disp && (
                                                                    <Typography variant="body1" color='link.main' textAlign={'right'} fontWeight={'bold'}>
                                                                        disponibles = {item.available}
                                                                    </Typography>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <Typography variant="h6" color='error.main' textAlign={'right'} fontWeight={'bold'}>Agotado</Typography>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        ))}
                                    </>
                                )}
                                
                                {continuar && (
                                    <Button variant="contained" sx={{ mt: 5 }} onClick={() => handleNext()}>
                                        {event.is_free ? 'Obtener Boletos' : 'Comprar Boletos'}
                                    </Button>
                                )}
                            </>
                        )}

                        {/* PASO 1: DATOS PERSONALES */}
                        {activeStep === 1 && (
                            <>
                                <SignInModal open={showModal} onClose={() => handleOnClose()}/>
                                <Grid container spacing={3} mt={3}>
                                    <Grid item xs={12}><Typography variant='h6'>Información del cliente</Typography><Divider/></Grid>
                                    
                                    <Grid item xs={12} sm={6}>
                                        <TextField fullWidth label="Nombre" value={name} onChange={(e) => setName(e.target.value)} onBlur={() => setNameError(name === '')} error={nameError} helperText={nameError && 'Ingrese el nombre'} />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField fullWidth label="Apellido" value={lastName} onChange={(e) => setLastName(e.target.value)} onBlur={() => setLastNameError(lastName === '')} error={lastNameError} helperText={lastNameError && 'Ingrese el apellido'} />
                                    </Grid>
                                    
                                    {event.is_document_mandatory && (
                                        <>
                                            <Grid item xs={4}>
                                                <TextField fullWidth label="Documento" select value={documentType} onChange={(e) => setDocumentType(e.target.value)}>
                                                    <MenuItem value='V'>V</MenuItem><MenuItem value='E'>E</MenuItem><MenuItem value='P'>P</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField fullWidth label="Número de documento" value={document} onChange={(e) => setDocument(e.target.value)} onBlur={() => setDocumentError(document === '')} error={documentError} helperText={documentError && 'Ingrese el número de documento'} />
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item xs={12}>
                                        <PhoneInput country={event.country_code?.toLowerCase() || 've'} specialLabel="Número de Teléfono" inputStyle={{ width: '100%' }} value={phoneNumber} onChange={(e) => setPhoneNumber(e)} onBlur={() => setPhoneNumberError(phoneNumber.length < 11)} />
                                        {phoneNumberError && <Typography variant="caption" color={'error.main'}>El número de teléfono es inválido</Typography>}
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField fullWidth label="Correo electrónico" value={email} onChange={(e) => setEmail(e.target.value)} onBlur={() => setEmailError(email === '')} error={emailError} helperText={emailError && 'Ingrese el correo electrónico'} />
                                    </Grid>
                                    
                                    {/* LÓGICA DINÁMICA: PROFESIÓN */}
                                    {event.requires_profession && (
                                        <>
                                            <Grid item xs={12}>
                                                <TextField fullWidth label="Nivel Profesional" select value={profession} onChange={(e) => setProfession(e.target.value)} onBlur={() => setProfessionError(profession === '')} error={professionError} helperText={professionError && 'Seleccione su nivel profesional'}>
                                                    <MenuItem value='Médico General'>Médico General</MenuItem>
                                                    <MenuItem value='Médico Especialista - '>Médico Especialista</MenuItem>
                                                    <MenuItem value='Médico Residente'>Médico Residente</MenuItem>
                                                    <MenuItem value='Estudiante'>Estudiante</MenuItem>
                                                    <MenuItem value='Otro - '>Otro</MenuItem>
                                                </TextField>
                                            </Grid>
                                            {(profession === "Médico Especialista - " || profession === "Otro - ") && (
                                                <Grid item xs={12}>
                                                    <TextField fullWidth label="Especialidad u otra profesión" value={especialista} onChange={(e) => setEspecialista(e.target.value)} />
                                                </Grid>
                                            )}
                                        </>
                                    )}

                                    {/* LÓGICA DINÁMICA: TÉRMINOS LEGALES (Reemplaza los ifs de Colombia y Rodamos ConValores) */}
                                    {event.custom_terms && (
                                        <Grid item xs={12}>
                                            <Typography fontWeight={'bold'} variant="h6" mb={2}>Términos y Condiciones</Typography>
                                            <ReactQuill 
                                                className="my-quill-container"
                                                theme={'bubble'} 
                                                readOnly={true} 
                                                modules={{ toolbar: false }} 
                                                value={event.custom_terms}
                                            />
                                            <Typography fontWeight={'bold'} mt={2}>
                                                Al hacer clic en "Continuar", aceptas los términos y condiciones del evento.
                                            </Typography>
                                        </Grid>
                                    )}

                                    <Grid item xs={12}>
                                        <ReCaptchaGoogle onChange={setReCaptcha} onAbort={() => setReCaptcha('')} onExpired={() => setReCaptcha('')} />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button disabled={reCaptcha === ''} fullWidth variant="contained" onClick={() => handleNext()}>
                                            <Typography>Continuar</Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        )}

                        {/* PASO 2: CHECKOUT / PAGOS */}
                        {activeStep === 2 && (
                            <>
                                <Typography variant="h6">Checkout</Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Paper elevation={4}>
                                            <Typography fontWeight={'bold'} p={1}>Resumen del pedido</Typography>
                                            <Box sx={{ p: 1 }}> 
                                                {sections.filter(item => item.cantidad > 0).map((item, idx) => (
                                                    <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography>{item.name} x {item.cantidad}</Typography>
                                                        <Typography>{(item.cantidad * item.price).toFixed(2)}</Typography>
                                                    </Box>
                                                ))}
                                                <Divider sx={{ mt: 2 }}/>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                                    <Typography>Subtotal</Typography>
                                                    <Typography>{subtotal.toFixed(2)}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    {/*<Typography>Fee QUD ({event.financial?.fee_percentage || 0}%)</Typography>*/}
                                                    <Typography>Fee QUD</Typography>
                                                    <Typography>{fee.toFixed(2)}</Typography>
                                                </Box>
                                                {event.seatsio_key && (
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography>seats fee</Typography>
                                                        <Typography>{feeSeats.toFixed(2)}</Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                            
                                            <Box sx={{ bgcolor: '#F5F8FC', p: 1, mt: 1, borderRadius: 3 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Typography>Total</Typography>
                                                    <Typography>{total.toFixed(2)} {event.financial?.base_currency || 'USD'}</Typography>
                                                </Box>

                                                {/* CONVERSIÓN DINÁMICA DE MONEDA A VES */}
                                                {event.financial?.local_currency === 'VES' && event.financial?.exchange_rate > 1 && (
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                                        <Typography variant="caption" color="text.secondary">Total en Bs (Tasa BCV: {event.financial.exchange_rate})</Typography>
                                                        <Typography variant="caption" color="text.secondary" fontWeight="bold">
                                                            {(total * event.financial.exchange_rate).toFixed(2)} VES
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Paper>
                                    </Grid>

                                    {total > 0 ? (
                                        <Grid item xs={12}>
                                            <Elements stripe={stripePromise} options={options}>
                                                <Payments
                                                    merchantUUID={event.merchant?.uuid}
                                                    event_id={event.id}
                                                    country={event.country_code || 'VE'}
                                                    title={`Entradas ${event.name}`}
                                                    customer={{
                                                        nombre: name,
                                                        apellido: lastName,
                                                        documento_tipo: documentType,
                                                        documento: document,
                                                        correo: email,
                                                        prefijo: prefix,
                                                        telefono: phoneNumber,
                                                        profesion: profession
                                                    }}
                                                    amount={parseFloat(total.toFixed(2))}
                                                    exchangeRate={event.financial?.exchange_rate}
                                                    currency={event.financial?.base_currency}
                                                    handleSubmit={handleSubmit}
                                                    action="Comprar Boletos"
                                                />
                                            </Elements>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={12}>
                                            <Button variant="contained" onClick={() => handleSubmit(true, null, true)}>
                                                <Typography>Obtener boletos gratis</Typography>
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Container>

            {continuar && activeStep === 0 && (
                <Box onClick={() => handleNext()} role="presentation" sx={{ position: 'fixed', bottom: 16, right: 16 }}>
                    <Fab variant="extended" sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}>
                        <FontAwesomeIcon icon={faTicket} />&nbsp;
                        {event.is_free ? "Obtener Boletos" : "Comprar Boletos"}
                    </Fab>
                </Box>
            )}
        </Box>
    );
}